export const GEO_AUTO_COMPLETION_REQUEST = 'GEO_AUTO_COMPLETION_REQUEST'
export const GEO_AUTO_COMPLETION_SCHEDULE = 'GEO_AUTO_COMPLETION_SCHEDULE'
